var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"animated-check-mark",staticClass:"check-mark-animation"})
}
var staticRenderFns = []

export { render, staticRenderFns }